import { Container, Icon, Label } from "./styles";
import { useTranslation } from "@/lib/translations";
import { useRouter } from "next/router";

type Props = {
  handleOpen: () => void;
};

const OpenFilters: React.FC<Props> = (props) => {
  const { handleOpen } = props;
  const { locale = "it" } = useRouter();
  const label = useTranslation("productListing.filtersButton", locale) || "";
  return (
    <Container role="button" onClick={() => handleOpen()}>
      <Label>{label}</Label>
      <Icon />
    </Container>
  );
};

export default OpenFilters;
